{
  "_about": "Character emotes (docs/62). The wire id of an emote is its index in `emotes`: append, never reorder or remove (the module and every client must agree). The first 8 are the wheel's inner ring (keys 1-8), the next 24 its outer ring, and the ones with `bard: true` (from id 32) a bard's own row under the wheel (docs/104 BD6; the module refuses them from any other class). `sheet` is the source sprite sheet in assets/source/licensed/tiny-rpg-emoji-pack-i/sheets/ (a `bard:` sheet is drawn by tools/emote-atlas.py itself: the pack's bubble with an original pixel instrument in it) (5x4 grid of 32 px frames, 16 used: 0-2 pop in, 3-13 the loop, 14-15 pop out); `frame` is the still the wheel shows. `tools/emote-atlas.py` packs them into apps/client/public/assets/emotes/emotes.png, one row per emote. Sounds: bank `emote.<key>` in content/audio/sfx.banks.json, timed by fk_sfx::emote.",
  "frame_px": 32,
  "frames": 16,
  "emotes": [
    {
      "key": "yes",
      "name": "Yes",
      "sheet": "Yes.png",
      "frame": 8
    },
    {
      "key": "no",
      "name": "No",
      "sheet": "No.png",
      "frame": 8
    },
    {
      "key": "ok",
      "name": "Thumbs up",
      "sheet": "Ok.png",
      "frame": 6
    },
    {
      "key": "laughing",
      "name": "Laughing",
      "sheet": "Laughing.png",
      "frame": 5
    },
    {
      "key": "love",
      "name": "Love",
      "sheet": "Love.png",
      "frame": 6
    },
    {
      "key": "question",
      "name": "?",
      "sheet": "Question.png",
      "frame": 4
    },
    {
      "key": "exclamation",
      "name": "!",
      "sheet": "Exclamation.png",
      "frame": 4
    },
    {
      "key": "angry",
      "name": "Angry",
      "sheet": "Angry.png",
      "frame": 4
    },
    {
      "key": "cute",
      "name": "Cute",
      "sheet": "Cute.png",
      "frame": 4
    },
    {
      "key": "eager",
      "name": "Star-struck",
      "sheet": "Eager.png",
      "frame": 4
    },
    {
      "key": "tongue",
      "name": "Cheeky",
      "sheet": "Tongue.png",
      "frame": 4
    },
    {
      "key": "kissing",
      "name": "Kissing",
      "sheet": "Kissing.png",
      "frame": 8
    },
    {
      "key": "drooling",
      "name": "Drooling",
      "sheet": "Drooling.png",
      "frame": 5
    },
    {
      "key": "lit",
      "name": "On fire",
      "sheet": "Lit.png",
      "frame": 6
    },
    {
      "key": "idea",
      "name": "Idea",
      "sheet": "Idea.png",
      "frame": 6
    },
    {
      "key": "thinking",
      "name": "Thinking",
      "sheet": "Thinking.png",
      "frame": 6
    },
    {
      "key": "neutral",
      "name": "Neutral",
      "sheet": "Neutral.png",
      "frame": 4
    },
    {
      "key": "silence",
      "name": "…",
      "sheet": "Silence.png",
      "frame": 8
    },
    {
      "key": "speechless",
      "name": "Speechless",
      "sheet": "Speechless.png",
      "frame": 4
    },
    {
      "key": "sleepy",
      "name": "Sleepy",
      "sheet": "Sleepy.png",
      "frame": 6
    },
    {
      "key": "sweat",
      "name": "Sweat",
      "sheet": "Sweat.png",
      "frame": 7
    },
    {
      "key": "dizzy",
      "name": "Dizzy",
      "sheet": "Dizzy.png",
      "frame": 5
    },
    {
      "key": "frustrated",
      "name": "Frustrated",
      "sheet": "Frustrated.png",
      "frame": 4
    },
    {
      "key": "crying",
      "name": "Crying",
      "sheet": "Crying.png",
      "frame": 5
    },
    {
      "key": "omg",
      "name": "OMG",
      "sheet": "OMG.png",
      "frame": 8
    },
    {
      "key": "headblown",
      "name": "Mind blown",
      "sheet": "Headblown.png",
      "frame": 6
    },
    {
      "key": "cant",
      "name": "No way",
      "sheet": "Cant.png",
      "frame": 5
    },
    {
      "key": "come",
      "name": "Come here",
      "sheet": "Come.png",
      "frame": 4
    },
    {
      "key": "up",
      "name": "Look up",
      "sheet": "Up.png",
      "frame": 6
    },
    {
      "key": "down",
      "name": "Thumbs down",
      "sheet": "Down.png",
      "frame": 4
    },
    {
      "key": "left",
      "name": "Over there (left)",
      "sheet": "Left.png",
      "frame": 4
    },
    {
      "key": "right",
      "name": "Over there (right)",
      "sheet": "Right.png",
      "frame": 4
    },
    {
      "key": "tune",
      "name": "Play a tune",
      "sheet": "bard:tune",
      "frame": 6,
      "bard": true
    },
    {
      "key": "drumroll",
      "name": "Drum roll",
      "sheet": "bard:drumroll",
      "frame": 6,
      "bard": true
    },
    {
      "key": "fanfare",
      "name": "Fanfare",
      "sheet": "bard:fanfare",
      "frame": 6,
      "bard": true
    },
    {
      "key": "serenade",
      "name": "Serenade",
      "sheet": "bard:serenade",
      "frame": 6,
      "bard": true
    },
    {
      "key": "lament",
      "name": "Lament",
      "sheet": "bard:lament",
      "frame": 6,
      "bard": true
    }
  ]
}
